import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitSubmission = async (payload) => {
  const res = await axios.post(`${API}/submissions`, payload);
  return res.data;
};

export const uploadSubmissionPhoto = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API}/submissions/upload-photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  // absolute URL zodat we het meteen kunnen tonen
  return { ...res.data, absoluteUrl: `${BACKEND_URL}${res.data.url}` };
};

export const MEMBERSHIP_OPTIONS = [
  { value: "BIZ-lid", label: "Ik ben BIZ-lid (binnen de zone)" },
  { value: "donateur", label: "Ik doe mee als donateur (buiten de zone)" },
];

export const CATEGORY_OPTIONS = [
  { value: "eten-drinken", label: "Eten & Drinken" },
  { value: "winkelen", label: "Winkelen" },
  { value: "mode", label: "Mode" },
  { value: "wonen-interieur", label: "Wonen & Interieur" },
  { value: "gezondheid-beauty", label: "Gezondheid & Beauty" },
  { value: "diensten", label: "Diensten" },
  { value: "overnachten", label: "Overnachten" },
  { value: "cultuur-vrije-tijd", label: "Cultuur & Vrije tijd" },
];
